import { TUser } from "@/features/auth/types";
import userTypes from "./user.types";


interface IUpdateUserConnected{
  type: userTypes.UPDATE_USER_CONNECTE,
  payload: TUser
}

export type UserAction = IUpdateUserConnected;

export const updateUserConnected = (user: TUser) => ({
    type: userTypes.UPDATE_USER_CONNECTE,
    payload: user
});

